import clsx from 'clsx';
import { getSiteStatusLabel, getSiteStatusColor } from '@/utils/format';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium tracking-wider',
        getSiteStatusColor(status),
        sizeClasses[size]
      )}
    >
      {getSiteStatusLabel(status)}
    </span>
  );
}
